import { LoadingIcon as LoadingDs } from "@packages/ds";
import styled from "styled-components";
export const ActivityListLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  padding-top: 0;
`;

export const ActivityListScroll = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0 -32px;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Loading = styled(LoadingDs)`
  margin: 10px auto;
`;
